
import React, { useRef, useState } from "react";
// Import Swiper React components
function HomePricing() {
  

  return (
    <div className="App">
 

{/* <!-- Blog Section End --> */}
<div class="section section-padding-02" >
            <div class="container" style={{maxWidth : '95%'}}>

                {/* <!-- Section Title Start --> */}
                <div class="section-title">
                    <h6 class="sub-title">Our Pricing Plans</h6>
                    <h2 class="main-title" style={{padding: '0px 150px'}}>Simple & transparent plans, choose what suits you best.</h2>
                </div>
                {/* <!-- Section Title End --> */}

 {/* <!-- Student's Widget Start --> */}
                        <div class="students-widget">
                            <div class="row">
                            <div class="col-lg-4">
            <div class="container">

                {/* <!-- Our Mission Wrapper Start --> */}
                <div class="single-student-widget widget-color-01">
                                    <h4 class="widget-title" style={{paddingTop : 20}}>BASIC PACKAGE
                                        {/* <p style={{fontSize : '14px'}}>One Month</p> */}
                                            </h4>
                                        

                                        <div class="widget-items">

                                        <div class="single-item" style={{paddingRight : 10}}>
                                                <div class="item-flag row">
                                                    {/* <div class="title" style={{whiteSpace : 'normal'}}><span class="dot"></span> </div> */}
                                                    <div class="title" style={{whiteSpace : 'normal'}}><span class="dot"></span> <strong>Ideal for:</strong> Beginners or those looking for general health support </div>
                                                
                                                </div>
                                               
                                            </div>
                                            {/* <!-- Single Item Start --> */}
                                            <div class="single-item" style={{paddingRight : 10}}>
                                                <div class="item-flag">
                                                   
                                                    <div class="title" style={{whiteSpace : 'normal'}}><span class="dot"></span> Weekly meal plans customized by Healthfitsquare's Senior Dietitian Team </div>
                                                </div>
                                               
                                            </div>
                                            {/* <!-- Single Item End --> */}


                                             {/* <!-- Single Item Start --> */}
                                             <div class="single-item" style={{paddingRight : 10}}>
                                                <div class="item-flag">
                                                   
                                                    <div class="title" style={{whiteSpace : 'normal'}}><span class="dot"></span> Focused on weight, health, or disease management</div>
                                                </div>
                                               
                                            </div>
                                            {/* <!-- Single Item End --> */}

                                              {/* <!-- Single Item Start --> */}
                                              <div class="single-item" style={{paddingRight : 10}}>
                                                <div class="item-flag">
                                                   
                                                    <div class="title" style={{whiteSpace : 'normal'}}><span class="dot"></span> <strong>Weekly audio consultation</strong> with our dietitian team</div>
                                                </div>
                                               
                                            </div>
                                            {/* <!-- Single Item End --> */}

                                             {/* <!-- Single Item Start --> */}
                                             <div class="single-item" style={{paddingRight : 10}}>
                                                <div class="item-flag">
                                                   
                                                    <div class="title" style={{whiteSpace : 'normal'}}><span class="dot"></span> <strong>Support hours:</strong> Monday-Saturday, 10:00 am to 07:00 pm IST</div>
                                                </div>
                                               
                                            </div>
                                            {/* <!-- Single Item End --> */}

                                             {/* <!-- Single Item Start --> */}
                                             <div class="single-item" style={{paddingRight : 10}}>
                                                <div class="item-flag">
                                                   
                                                    <div class="title" style={{whiteSpace : 'normal'}}><span class="dot"></span> Lifestyle guidance: portion control, healthy eating habits, and maintenance</div>
                                                </div>
                                               
                                            </div>
                                            {/* <!-- Single Item End --> */}


                                             {/* <!-- Single Item Start --> */}
                                             <div class="single-item" style={{paddingRight : 10}}>
                                                <div class="item-flag">
                                                   
                                                    <div class="title" style={{whiteSpace : 'normal'}}><span class="dot"></span> Regular follow-up with flexible diet plans</div>
                                                </div>
                                               
                                            </div>
                                            {/* <!-- Single Item End --> */}

                                             {/* <!-- Single Item Start --> */}
                                             <div class="single-item" style={{paddingRight : 10}}>
                                                <div class="item-flag">
                                                   
                                                    {/* <div class="title" style={{whiteSpace : 'normal'}}><span class="dot"></span> Regular follow up with flexible Diet Plan</div> */}
                                                </div>
                                               
                                            </div>
                                            {/* <!-- Single Item End --> */}

                                            <h4 class="widget-title" style={{marginTop : 30, background: '#0a4d3c', color: '#fff'}}>Contact Now</h4>

                                        </div>

                                       
                                    </div>
                {/* <!-- Our Mission Wrapper End --> */}

            </div>
        </div>
        {/* <!-- Our Mission & Vission Section End --> */}

        {/* <!-- Our Mission & Vission Section Start --> */}
        <div class="col-lg-4">
            <div class="container">

                {/* <!-- Our Mission Wrapper Start --> */}
                <div class="single-student-widget widget-color-03">
                                        <h4 class="widget-title" style={{paddingTop : 20}}>EXCLUSIVE PACKAGE
                                        {/* <p style={{fontSize : '14px'}}>One Month</p> */}
                                            </h4>
                                        

                                        <div class="widget-items">

                                            {/* <!-- Single Item Start --> */}
                                            <div class="single-item" style={{paddingRight : 10}}>
                                                <div class="item-flag">
                                                   
                                                    <div class="title" style={{whiteSpace : 'normal'}}><span class="dot"></span> <strong>Ideal for:</strong> Those looking for deeper guidance and more personalized care </div>
                                                </div>
                                               
                                            </div>
                                            {/* <!-- Single Item End --> */}


                                             {/* <!-- Single Item Start --> */}
                                             <div class="single-item" style={{paddingRight : 10}}>
                                                <div class="item-flag">
                                                   
                                                    <div class="title" style={{whiteSpace : 'normal'}}><span class="dot"></span> Customized meal plans by <strong>senior dietitians under Neha Yaduvanshi’s guidance</strong></div>
                                                </div>
                                               
                                            </div>
                                            {/* <!-- Single Item End --> */}

                                              {/* <!-- Single Item Start --> */}
                                              <div class="single-item" style={{paddingRight : 10}}>
                                                <div class="item-flag">
                                                   
                                                    <div class="title" style={{whiteSpace : 'normal'}}><span class="dot"></span>Tailored plans for weight loss, disease-specific needs, or health goals</div>
                                                </div>
                                               
                                            </div>
                                            {/* <!-- Single Item End --> */}

                                             {/* <!-- Single Item Start --> */}
                                             <div class="single-item" style={{paddingRight : 10}}>
                                                <div class="item-flag">
                                                   
                                                    <div class="title" style={{whiteSpace : 'normal'}}><span class="dot"></span> <strong>Weekly audio consultation</strong> with our dietitian team</div>
                                                </div>
                                               
                                            </div>
                                            {/* <!-- Single Item End --> */}

                                             {/* <!-- Single Item Start --> */}
                                             <div class="single-item" style={{paddingRight : 10}}>
                                                <div class="item-flag">
                                                   
                                                    <div class="title" style={{whiteSpace : 'normal'}}><span class="dot"></span> Lifestyle Guidance, guides for Portion control, eating out and Maintenance</div>
                                                </div>
                                               
                                            </div>
                                            {/* <!-- Single Item End --> */}

                                             {/* <!-- Single Item Start --> */}
                                             <div class="single-item" style={{paddingRight : 10}}>
                                                <div class="item-flag">
                                                   
                                                    <div class="title" style={{whiteSpace : 'normal'}}><span class="dot"></span> <strong>Support hours:</strong> Monday-Saturday, 10:00 am to 07:00 pm IST</div>
                                                </div>
                                               
                                            </div>
                                            {/* <!-- Single Item End --> */}


                                             {/* <!-- Single Item Start --> */}
                                             <div class="single-item" style={{paddingRight : 10}}>
                                                <div class="item-flag">
                                                   
                                                    <div class="title" style={{whiteSpace : 'normal'}}><span class="dot"></span> Lifestyle and habit correction: eating out tips, portion control, meal timing</div>
                                                </div>
                                               
                                            </div>

                                            <div class="single-item" style={{paddingRight : 10}}>
                                                <div class="item-flag">
                                                   
                                                    <div class="title" style={{whiteSpace : 'normal'}}><span class="dot"></span> Continuous follow-ups and dynamic diet modifications</div>
                                                </div>
                                               
                                            </div>
                                            {/* <!-- Single Item End --> */}

                                            <h4 class="widget-title" style={{marginTop : 30, background: '#0a4d3c', color: '#fff'}}>Contact Now</h4>

                                        </div>

                                       
                                    </div>
                {/* <!-- Our Mission Wrapper End --> */}

            </div>
        </div>
        {/* <!-- Our Mission & Vission Section End --> */}

        <div class="col-lg-4">
            <div class="container">

                {/* <!-- Our Mission Wrapper Start --> */}
                <div class="single-student-widget widget-color-02">
                                        <h4 class="widget-title" style={{paddingTop : 20}}>PERSONALISED PACKAGE<br/><h6>One-on-One with Dt. Neha Yaduvanshi</h6>
                                        {/* <p style={{fontSize : '14px'}}>One Month</p> */}
                                            </h4>
                                        

                                        <div class="widget-items">

                                            {/* <!-- Single Item Start --> */}
                                            <div class="single-item" style={{paddingRight : 10}}>
                                                <div class="item-flag">
                                                   
                                                    <div class="title" style={{whiteSpace : 'normal'}}><span class="dot"></span> <strong>Ideal for:</strong> Those needing premium, highly personalized care </div>
                                                </div>
                                               
                                            </div>
                                            {/* <!-- Single Item End --> */}

 {/* <!-- Single Item Start --> */}
 <div class="single-item" style={{paddingRight : 10}}>
                                                <div class="item-flag">
                                                   
                                                    <div class="title" style={{whiteSpace : 'normal'}}><span class="dot"></span> Personally designed meal plans by <strong>Dt. Neha Yaduvanshi</strong></div>
                                                </div>
                                               
                                            </div>
                                            {/* <!-- Single Item End --> */}

                                             {/* <!-- Single Item Start --> */}
                                             <div class="single-item" style={{paddingRight : 10}}>
                                                <div class="item-flag">
                                                   
                                                    <div class="title" style={{whiteSpace : 'normal'}}><span class="dot"></span> Holistic management for weight, chronic health issues, or recovery </div>
                                                </div>
                                               
                                            </div>
                                            {/* <!-- Single Item End --> */}

                                             {/* <!-- Single Item Start --> */}
                                             <div class="single-item" style={{paddingRight : 10}}>
                                                <div class="item-flag">
                                                   
                                                    <div class="title" style={{whiteSpace : 'normal'}}><span class="dot"></span> <strong>Weekly video consultations</strong> directly with Dt. Neha Yaduvanshi </div>
                                                </div>
                                               
                                            </div>
                                            {/* <!-- Single Item End --> */}

                                              {/* <!-- Single Item Start --> */}
                                              <div class="single-item" style={{paddingRight : 10}}>
                                                <div class="item-flag">
                                                   
                                                    <div class="title" style={{whiteSpace : 'normal'}}><span class="dot"></span> <strong>Priority support</strong> from Monday–Saturday, 10:00 AM – 7:00 PM IST</div>
                                                </div>
                                               
                                            </div>
                                            {/* <!-- Single Item End --> */}

                                             {/* <!-- Single Item Start --> */}
                                             <div class="single-item" style={{paddingRight : 10}}>
                                                <div class="item-flag">
                                                   
                                                    <div class="title" style={{whiteSpace : 'normal'}}><span class="dot"></span> In-depth lifestyle coaching: advanced portion guidance, eating out, maintenance strategies</div>
                                                </div>
                                               
                                            </div>
                                            {/* <!-- Single Item End --> */}

                                             {/* <!-- Single Item Start --> */}
                                             <div class="single-item" style={{paddingRight : 10}}>
                                                <div class="item-flag">
                                                   
                                                    <div class="title" style={{whiteSpace : 'normal'}}><span class="dot"></span> Frequent follow-ups with highly adaptive diet planning</div>
                                                </div>
                                               
                                            </div>
                                            {/* <!-- Single Item End --> */}
                                            <div class="single-item" style={{paddingRight : 10}}>
                                                <div class="item-flag">
                                                   
                                                    {/* <div class="title" style={{whiteSpace : 'normal'}}><span class="dot"></span> Regular follow up with flexible Diet Plan</div> */}
                                                </div>
                                               
                                            </div>
                                           
                                            {/* <!-- Single Item End --> */}

                                            <h4 class="widget-title" style={{marginTop : 15, background: '#0a4d3c', color: '#fff'}}>Contact Now</h4>

                                        </div>

                                       
                                    </div>
                {/* <!-- Our Mission Wrapper End --> */}

            </div>
        </div>
                                
                            </div>
                        </div>
                        {/* <!-- Student's Widget End --> */}


                        </div>
                        </div>
                
                    

    </div>
  );
}

export default HomePricing;
